export default {
  title: 'SEO',
  og_locale: {
    pt_BR: "Português (Brasil)",
    pt_PT: "Português (Portugal)",
    en_US: "English (United States)",
    es_ES: "Español (España)",
    ja_JP: "日本語",
    options: [
      { value: "pt_BR", label: "Português (Brasil)" },
      { value: "pt_PT", label: "Português (Portugal)" },
      { value: "en_US", label: "English (United States)" },
      { value: "es_ES", label: "Español (España)" },
      { value: "ja_JP", label: "日本語" }
    ]
  },
  og_type: {
    website: "Site",
    article: "Artigo",
    profile: "Perfil",
    book: "Livro",
    "music.song": "Música",
    "music.album": "Álbum de música",
    "music.playlist": "Playlist",
    "music.radio_station": "Rádio",
    "video.movie": "Filme",
    "video.episode": "Episódio",
    "video.tv_show": "Programa de TV",
    "video.other": "Vídeo",
    options: [
      { value: "website", label: "Site" },
      { value: "article", label: "Artigo" },
      { value: "profile", label: "Perfil" },
      { value: "book", label: "Livro" },
      { value: "music.song", label: "Música" },
      { value: "music.album", label: "Álbum de música" },
      { value: "music.playlist", label: "Playlist" },
      { value: "music.radio_station", label: "Rádio" },
      { value: "video.movie", label: "Filme" },
      { value: "video.episode", label: "Episódio" },
      { value: "video.tv_show", label: "Programa de TV" },
      { value: "video.other", label: "Vídeo" }
    ]
  },
  schema_type: {
    Organization: "Organização",
    LocalBusiness: "Negócio local",
    Person: "Pessoa",
    WebSite: "Site",
    WebPage: "Página web",
    Article: "Artigo",
    Product: "Produto",
    Service: "Serviço",
    BreadcrumbList: "Lista de navegação",
    FAQPage: "FAQ",
    options: [
      { value: "Organization", label: "Organização" },
      { value: "LocalBusiness", label: "Negócio local" },
      { value: "Person", label: "Pessoa" },
      { value: "WebSite", label: "Site" },
      { value: "WebPage", label: "Página web" },
      { value: "Article", label: "Artigo" },
      { value: "Product", label: "Produto" },
      { value: "Service", label: "Serviço" },
      { value: "BreadcrumbList", label: "Lista de navegação" },
      { value: "FAQPage", label: "FAQ" }
    ]
  },
  sitemap_changefreq: {
    always: "Sempre",
    hourly: "A cada hora",
    daily: "Diariamente",
    weekly: "Semanalmente",
    monthly: "Mensalmente",
    yearly: "Anualmente",
    never: "Nunca",
    options: [
      { value: "always", label: "Sempre" },
      { value: "hourly", label: "A cada hora" },
      { value: "daily", label: "Diariamente" },
      { value: "weekly", label: "Semanalmente" },
      { value: "monthly", label: "Mensalmente" },
      { value: "yearly", label: "Anualmente" },
      { value: "never", label: "Nunca" }
    ]
  },
  sitemap_priority: {
    "0.1": "0.1 - Muito baixa",
    "0.2": "0.2",
    "0.3": "0.3",
    "0.4": "0.4",
    "0.5": "0.5 - Normal",
    "0.6": "0.6",
    "0.7": "0.7",
    "0.8": "0.8 - Alta",
    "0.9": "0.9",
    "1.0": "1.0 - Máxima",
    options: [
      { value: "0.1", label: "0.1 - Muito baixa" },
      { value: "0.2", label: "0.2" },
      { value: "0.3", label: "0.3" },
      { value: "0.4", label: "0.4" },
      { value: "0.5", label: "0.5 - Normal" },
      { value: "0.6", label: "0.6" },
      { value: "0.7", label: "0.7" },
      { value: "0.8", label: "0.8 - Alta" },
      { value: "0.9", label: "0.9" },
      { value: "1.0", label: "1.0 - Máxima" }
    ]
  },
  trailing_slash_mode: {
    none: "Não alterar",
    force_slash: "Forçar barra final",
    remove_slash: "Remover barra final",
    options: [
      { value: "none", label: "Não alterar" },
      { value: "force_slash", label: "Forçar barra final" },
      { value: "remove_slash", label: "Remover barra final" }
    ]
  },
  twitter_card: {
    summary: "Resumo",
    summary_large_image: "Resumo com imagem grande",
    app: "Aplicativo",
    player: "Player",
    options: [
      { value: "summary", label: "Resumo" },
      { value: "summary_large_image", label: "Resumo com imagem grande" },
      { value: "app", label: "Aplicativo" },
      { value: "player", label: "Player" }
    ]
  },
  www_mode: {
    none: 'Não Alterar',
    force_www: 'Forçar www',
    force_non_www: 'Remover www',
    options: [
      { value: "none", label: "Não alterar" },
      { value: "force_www", label: "Forçar www" },
      { value: "force_non_www", label: "Remover www" }
    ]
  },
  groups: {
    seo: 'SEO',
    base: 'SEO - Base',
    url: 'SEO - URL',
    robots: 'SEO - Robots',
    sitemap: 'SEO - Sitemap',
    og: 'SEO - OpenGraph',
    twitter: 'SEO - X',
    verification: 'SEO - Verificação',
    schema: 'SEO - Schema',
    organization: 'SEO - Organização'
  },
  fields: {
    address:'Endereço',
    author: 'Autor',
    bing: 'Bing',
    canonical: 'URL Canônica',
    card: 'Cartão',
    changefreq: 'Alterar frequência',
    choice_image:'Ecolher Imagem',
    description: 'Descrição',
    email: 'E-mail',
    enabled: 'Habilitado',
    follow: 'Seguir',
    force_https: 'Forçar HTTPS',
    google:'Google',
    image: 'Imagem',
    image_alt: 'Nome da imagem',
    include_images: 'Incluir imagens',
    index: 'Indexar',
    keywords: 'Palavras-Chave',
    locale: 'Idioma',
    logo: 'Logo',
    noarchive: 'Sem arquivo',
    noimageindex: 'Sem indexar imagem',
    nosnippet: 'Sem trecho',
    organization_name: 'Organização',
    page_name: 'Nome da Página',
    phone: 'Telefone',
    pinterest: 'Pinterest',
    priority: 'Prioridade',
    same_as: 'Igual a',
    schema: 'Esquema',
    site_name: 'Nome do Site',
    title: 'Título',
    trailing_slash_mode: 'Barra final',
    txt_extra:'Texto Extra',
    txt_enabled:'Texto Extra Habilitado',
    type: 'Tipo',
    url:'URL',
    www_mode: 'Modo www',
    yandex: 'Yandex'
  },
  audit: {
    severity: {
      critical: 'Critico',
      warning: 'Atencao',
      info: 'Info'
    },
    status: {
      good: 'Bom',
      great: 'Otimo',
      excellent: 'Excelente',
      attention: 'Atencao',
      critical: 'Critico'
    },
    categories: {
      content: 'Conteudo',
      metadata: 'Metadata',
      html: 'HTML',
      'structured-data': 'Structured-Data',
      technical: 'Technical'
    },
    report: {
      status: 'Status',
      score: 'Score',
      preview: 'Preview',
      unavailable: 'Indisponivel',
      critical_count: 'criticos',
      warning_count: 'alertas',
      info_count: 'informativos',
      no_relevant_issues: 'Nenhum problema relevante encontrado.',
      limitations: 'Limitacoes da auditoria',
      limitation_item: 'Observacao',
      issue: 'Ocorrencia',
      correct: 'Corrigir',
      how_to_validate: 'Como validar'
    },
    errors: {
      page_not_found: 'Pagina nao encontrada para analise SEO.',
      tenant_context_required: 'Contexto de tenant ausente para analise SEO.',
      page_context_required: 'Contexto de pagina ausente para analise SEO.',
      analysis_failed: 'Nao foi possivel concluir a analise SEO.'
    },
    issues: {
      h1_missing: {
        title: 'H1 ausente',
        message: 'Nenhum campo do layout foi marcado ou preenchido como H1.',
        recommendation: 'Preencha um H1 principal para a pagina.'
      },
      multiple_h1_semantic: {
        title: 'Mais de um H1 semanticamente mapeado',
        message: 'Foram encontrados {count} blocos de H1 no conteudo do CMS.',
        recommendation: 'Mantenha um H1 principal e rebaixe os demais para H2 ou H3.'
      },
      shallow_subtitle_structure: {
        title: 'Estrutura de subtitulos rasa',
        message: 'Nenhum H2 foi encontrado no conteudo mapeado do layout.',
        recommendation: 'Adicione subtitulos para estruturar melhor a leitura.'
      },
      short_main_content: {
        title: 'Conteudo textual curto',
        message: 'O conteudo principal tem cerca de {count} palavras visiveis.',
        recommendation: 'Expanda o texto principal com contexto, prova e detalhes uteis.'
      },
      missing_semantic_cta: {
        title: 'CTA sem marcacao semantica efetiva',
        message: 'Nenhum CTA preenchido foi identificado a partir das marcacoes seo do layout.',
        recommendation: 'Preencha ao menos uma chamada para acao relevante quando fizer sentido.'
      },
      missing_specific_seo_title: {
        title: 'Titulo SEO especifico ausente',
        message: 'A pagina esta dependendo do fallback global do site para compor o title.',
        recommendation: 'Defina um seo_title especifico para esta pagina.'
      },
      missing_final_title: {
        title: 'Title ausente',
        message: 'Nenhum title SEO final pode ser resolvido.',
        recommendation: 'Preencha seo_title da pagina ou o titulo global do site.'
      },
      title_out_of_range: {
        title: 'Title fora da faixa recomendada',
        message: 'O title final tem {count} caracteres.',
        recommendation: 'Mantenha o title entre 15 e 65 caracteres, com intencao clara.'
      },
      missing_meta_description: {
        title: 'Meta description ausente',
        message: 'Nenhuma descricao SEO final foi resolvida para a pagina.',
        recommendation: 'Preencha uma descricao especifica em seo_default_description.'
      },
      meta_description_out_of_range: {
        title: 'Meta description fora da faixa sugerida',
        message: 'A descricao final tem {count} caracteres.',
        recommendation: 'Busque algo entre 70 e 170 caracteres uteis e objetivos.'
      },
      indexable_preview: {
        title: 'Preview potencialmente indexavel',
        message: 'A pagina de preview esta com indexacao permitida no nivel do conteudo.',
        recommendation: 'Desative indexacao no preview ou force noindex no HTML de preview.'
      },
      missing_canonical_base: {
        title: 'Base canonical do site ausente',
        message: 'O site nao possui seo_canonical_base_url configurado.',
        recommendation: 'Configure a base canonical publica para o dominio de producao.'
      },
      missing_global_social_image: {
        title: 'Imagem social global ausente',
        message: 'Open Graph e Twitter Card nao tem imagem global configurada.',
        recommendation: 'Defina ao menos uma imagem social padrao no site.'
      },
      public_html_not_audited_local: {
        title: 'HTML publico nao auditado em ambiente local',
        message: 'A validacao do HTML publico foi ignorada porque a auditoria esta rodando em ambiente local.',
        recommendation: 'Publique ou rode a auditoria em ambiente online para validar a versao publica.'
      },
      html_unavailable: {
        title: 'HTML {mode} indisponivel',
        message: '{error}',
        fallback_error: 'Nao foi possivel carregar a versao {mode} para validacao de HTML.',
        recommendation: 'Revise conectividade local ou a rota renderizada para habilitar analise de HTML.'
      },
      dynamic_html_not_audited: {
        title: 'HTML {mode} dinamico nao auditado sem execucao JS',
        message: 'A resposta {mode} acessada pelo auditor e a casca do app SPA, nao o DOM final hidratado.',
        recommendation: 'Valide title, meta tags, lang, H1, robots e schema com renderizacao real do navegador ou habilite uma etapa headless no ambiente.'
      },
      missing_title_tag: {
        title: 'Title tag ausente',
        message: 'O HTML {mode} nao contem <title>.',
        recommendation: 'Garanta a renderizacao do title final no head.'
      },
      missing_html_meta_description: {
        title: 'Meta description ausente',
        message: 'O HTML {mode} nao contem meta description.',
        recommendation: 'Renderize a description final no head.'
      },
      missing_html_lang: {
        title: 'Lang ausente no HTML',
        message: 'O HTML {mode} nao define <html lang>.',
        recommendation: 'Defina o idioma final da pagina no elemento html.'
      },
      missing_rendered_h1: {
        title: 'H1 ausente no HTML renderizado',
        message: 'O HTML {mode} nao possui H1 real.',
        recommendation: 'Garanta que o H1 do CMS chegue ao HTML final.'
      },
      multiple_rendered_h1: {
        title: 'Mais de um H1 no HTML renderizado',
        message: 'O HTML {mode} possui {count} H1s.',
        recommendation: 'Mantenha um unico H1 por pagina.'
      },
      preview_missing_noindex: {
        title: 'Preview sem noindex',
        message: 'O HTML de preview nao expoe meta robots com noindex.',
        recommendation: 'Force noindex,nofollow no ambiente de preview.'
      },
      canonical_pointing_preview_local: {
        title: 'Canonical apontando para preview/local',
        message: 'O canonical renderizado aponta para ambiente de preview ou local.',
        recommendation: 'Aponte o canonical para a URL publica de producao.'
      },
      dynamic_schema_not_audited: {
        title: 'Schema dinamico nao auditado sem execucao JS',
        message: 'O auditor recebeu apenas a casca do app e nao consegue confirmar JSON-LD injetado dinamicamente.',
        recommendation: 'Valide o schema com renderizacao real do navegador ou habilite uma etapa headless no ambiente.'
      },
      missing_json_ld: {
        title: 'JSON-LD ausente',
        message: 'Nenhum bloco JSON-LD foi encontrado no HTML renderizado.',
        recommendation: 'Adicione schema quando fizer sentido para o tipo da pagina.'
      },
      invalid_json_ld: {
        title: 'JSON-LD invalido',
        message: 'Um bloco JSON-LD presente no HTML nao e JSON valido.',
        recommendation: 'Corrija a serializacao do schema antes da publicacao.'
      },
      preview_unavailable: {
        title: 'Preview inacessivel para auditoria',
        message: '{error}',
        fallback_error: 'O preview nao respondeu para analise tecnica.',
        recommendation: 'Verifique roteamento local, host de preview e disponibilidade do app.'
      },
      public_url_not_audited_local: {
        title: 'URL publica nao auditada em ambiente local',
        message: 'A checagem da URL publica foi ignorada porque esta auditoria esta rodando em ambiente local.',
        recommendation: 'Valide a URL publica depois do deploy ou em um ambiente acessivel externamente.'
      },
      headless_unavailable: {
        title: 'Renderizacao headless indisponivel no ambiente',
        message: '{error}',
        recommendation: 'Instale e disponibilize o navegador usado pela auditoria no container/API para validar HTML e schema renderizados.'
      },
      public_url_unavailable: {
        title: 'URL publica indisponivel no momento da auditoria',
        message: '{error}',
        fallback_error: 'A URL publica nao respondeu durante a analise.',
        recommendation: 'Confirme se a pagina publicada esta acessivel externamente.'
      }
    }
  }
}
